import { ReactNode } from "react";
import styles from "./CheckpointBullet.module.css";
import { Box } from "@mui/material";
    
export function CheckpointBullet({children}: {children: ReactNode}) {
    return <Box className={styles.root}>{children}</Box>
}